// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smile-studio {
  --ss-bg: #16171a;
  --ss-shell: #1c1d20;
  --ss-panel: #212226;
  --ss-card: #26282c;
  --ss-border: rgba(255, 255, 255, 0.07);
  --ss-border-strong: rgba(255, 255, 255, 0.14);
  --ss-text: #f1f0ea;
  --ss-text-dim: #a5a6ac;
  --ss-text-faint: #6b6c72;
  --ss-teal: #1da8c6;
  --ss-teal-soft: rgba(29, 168, 198, 0.14);
  font-family: "Inter", sans-serif;
  color: var(--ss-text);
  -webkit-font-smoothing: antialiased;
}

.smile-studio h1,
.smile-studio h2,
.smile-studio h3,
.smile-studio .ss-display {
  font-family: "Poppins", sans-serif;
}

.smile-studio .ss-mono {
  font-family: "IBM Plex Mono", monospace;
  letter-spacing: 0.02em;
}

/* Allow true mobile layout inside smile portal (overrides index.html touch min-width) */
@media (max-width: 767px) {
  body {
    min-width: 0 !important;
  }
}

.smile-studio .ss-stepper-scroll {
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.smile-studio .ss-stepper-scroll::-webkit-scrollbar {
  display: none;
}

@keyframes ss-arrow-inout {
  0%,
  100% {
    opacity: 0.28;
    transform: translateX(-2px);
  }
  50% {
    opacity: 1;
    transform: translateX(3px);
  }
}

.ss-stepper-arrow-active {
  animation: ss-arrow-inout 1.15s ease-in-out infinite;
}

@keyframes ss-stage-next-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(29, 168, 198, 0.45);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(29, 168, 198, 0);
  }
}

.ss-stepper-next {
  animation: ss-stage-next-pulse 1.6s ease-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .ss-stepper-arrow-active,
  .ss-stepper-next {
    animation: none;
    opacity: 1;
    transform: none;
    box-shadow: none;
  }
}

/*
 * Smile portal scrollbars — thin teal thumb on dark track.
 * Applied via body.smile-portal-active so portaled modals are included too.
 */
body.smile-portal-active,
body.smile-portal-active *,
.smile-dark-scroll,
.smile-studio-scroll-root {
  scrollbar-width: thin;
  scrollbar-color: rgba(47, 169, 191, 0.45) rgba(255, 255, 255, 0.05);
}

body.smile-portal-active::-webkit-scrollbar,
body.smile-portal-active *::-webkit-scrollbar,
.smile-dark-scroll::-webkit-scrollbar,
.smile-studio-scroll-root::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

body.smile-portal-active::-webkit-scrollbar-track,
body.smile-portal-active *::-webkit-scrollbar-track,
.smile-dark-scroll::-webkit-scrollbar-track,
.smile-studio-scroll-root::-webkit-scrollbar-track {
  background: transparent;
}

body.smile-portal-active::-webkit-scrollbar-thumb,
body.smile-portal-active *::-webkit-scrollbar-thumb,
.smile-dark-scroll::-webkit-scrollbar-thumb,
.smile-studio-scroll-root::-webkit-scrollbar-thumb {
  background: rgba(47, 169, 191, 0.4);
  border-radius: 999px;
}

body.smile-portal-active::-webkit-scrollbar-thumb:hover,
body.smile-portal-active *::-webkit-scrollbar-thumb:hover,
.smile-dark-scroll::-webkit-scrollbar-thumb:hover,
.smile-studio-scroll-root::-webkit-scrollbar-thumb:hover {
  background: rgba(54, 191, 216, 0.7);
}

body.smile-portal-active::-webkit-scrollbar-button,
body.smile-portal-active *::-webkit-scrollbar-button,
.smile-dark-scroll::-webkit-scrollbar-button,
.smile-studio-scroll-root::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

/* Keep stepper and style slider hidden even while portal scrollbar styles are active */
body.smile-portal-active .ss-stepper-scroll::-webkit-scrollbar,
.smile-studio .ss-stepper-scroll::-webkit-scrollbar,
body.smile-portal-active .smile-style-slider::-webkit-scrollbar,
.smile-studio .smile-style-slider::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

body.smile-portal-active .ss-stepper-scroll,
.smile-studio .ss-stepper-scroll,
body.smile-portal-active .smile-style-slider,
.smile-studio .smile-style-slider {
  scrollbar-width: none;
}

.smile-filter-slider-wrap {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 220px;
  overflow: hidden;
  border-radius: 15px;
}

.smile-style-slider {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 0;
  scroll-behavior: smooth;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
}

.smile-style-slider::-webkit-scrollbar {
  display: none;
  height: 0;
  width: 0;
}

.smile-filter-slide {
  position: relative;
  flex: 0 0 auto;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.smile-filter-slide:hover {
  z-index: 1;
}

.smile-filter-slide img {
  height: 100%;
  width: auto;
  max-height: 100%;
  margin: 0;
  object-fit: contain;
  object-position: center;
  border-radius: 0;
  cursor: pointer;
  transition: 0.25s ease-in-out;
  display: block;
  background: #c1c1c3;
}

.smile-filter-slide-empty {
  height: 100%;
  width: 250px;
  margin: 0;
  border-radius: 0;
  cursor: pointer;
  transition: 0.25s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b6c72;
  font-size: 12px;
  background: #1f2124;
}

.smile-filter-slide img:hover,
.smile-filter-slide-empty:hover {
  transform: scale(1.05);
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.35);
}

.smile-filter-slide.is-selected {
  z-index: 1;
}

.smile-filter-slide.is-selected::after {
  content: "";
  position: absolute;
  inset: 0;
  border: 3px solid #1da8c6;
  pointer-events: none;
  z-index: 2;
}

.smile-filter-slide.is-selected img,
.smile-filter-slide.is-selected .smile-filter-slide-empty {
  transform: none;
  box-shadow: none;
}

.smile-filter-slide.is-selected img:hover,
.smile-filter-slide.is-selected .smile-filter-slide-empty:hover {
  transform: none;
  box-shadow: none;
}

.smile-filter-slide-name {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
  padding: 6px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  line-height: 1.25;
  white-space: normal;
  background: rgba(0, 0, 0, 0.65);
  opacity: 0;
  pointer-events: none;
  z-index: 3;
  transition: opacity 0.2s ease;
}

.smile-filter-slide:hover .smile-filter-slide-name,
.smile-filter-slide.is-selected .smile-filter-slide-name {
  opacity: 1;
}

.smile-filter-slide.is-selected .smile-filter-slide-name {
  background: #1da8c6;
  color: #08151a;
}

.smile-filter-control {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 2;
  height: auto;
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(28, 29, 32, 0.72);
  color: #f1f0ea;
  border: 0;
  cursor: pointer;
  user-select: none;
}

.smile-filter-control.prev {
  left: 0;
}

.smile-filter-control.next {
  right: 0;
}

.smile-filter-control:hover {
  background: rgba(29, 168, 198, 0.85);
  color: #08151a;
}

@media (max-width: 420px) {
  .smile-filter-slider-wrap {
    height: 180px;
  }

  .smile-filter-slide-empty {
    width: 180px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/smileStudio.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,6CAA6C;EAC7C,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,wFAAwF;AACxF;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,aAAa;IACb,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE;;IAEE,4CAA4C;EAC9C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE;;IAEE,eAAe;IACf,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;;EAGE;AACF;;;;EAIE,qBAAqB;EACrB,mEAAmE;AACrE;;AAEA;;;;EAIE,UAAU;EACV,WAAW;AACb;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;EAIE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;;;EAIE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA,uFAAuF;AACvF;;;;EAIE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;EACd,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap\");\n\n.smile-studio {\n  --ss-bg: #16171a;\n  --ss-shell: #1c1d20;\n  --ss-panel: #212226;\n  --ss-card: #26282c;\n  --ss-border: rgba(255, 255, 255, 0.07);\n  --ss-border-strong: rgba(255, 255, 255, 0.14);\n  --ss-text: #f1f0ea;\n  --ss-text-dim: #a5a6ac;\n  --ss-text-faint: #6b6c72;\n  --ss-teal: #1da8c6;\n  --ss-teal-soft: rgba(29, 168, 198, 0.14);\n  font-family: \"Inter\", sans-serif;\n  color: var(--ss-text);\n  -webkit-font-smoothing: antialiased;\n}\n\n.smile-studio h1,\n.smile-studio h2,\n.smile-studio h3,\n.smile-studio .ss-display {\n  font-family: \"Poppins\", sans-serif;\n}\n\n.smile-studio .ss-mono {\n  font-family: \"IBM Plex Mono\", monospace;\n  letter-spacing: 0.02em;\n}\n\n/* Allow true mobile layout inside smile portal (overrides index.html touch min-width) */\n@media (max-width: 767px) {\n  body {\n    min-width: 0 !important;\n  }\n}\n\n.smile-studio .ss-stepper-scroll {\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.smile-studio .ss-stepper-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n@keyframes ss-arrow-inout {\n  0%,\n  100% {\n    opacity: 0.28;\n    transform: translateX(-2px);\n  }\n  50% {\n    opacity: 1;\n    transform: translateX(3px);\n  }\n}\n\n.ss-stepper-arrow-active {\n  animation: ss-arrow-inout 1.15s ease-in-out infinite;\n}\n\n@keyframes ss-stage-next-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(29, 168, 198, 0.45);\n  }\n  50% {\n    box-shadow: 0 0 0 6px rgba(29, 168, 198, 0);\n  }\n}\n\n.ss-stepper-next {\n  animation: ss-stage-next-pulse 1.6s ease-out infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ss-stepper-arrow-active,\n  .ss-stepper-next {\n    animation: none;\n    opacity: 1;\n    transform: none;\n    box-shadow: none;\n  }\n}\n\n/*\n * Smile portal scrollbars — thin teal thumb on dark track.\n * Applied via body.smile-portal-active so portaled modals are included too.\n */\nbody.smile-portal-active,\nbody.smile-portal-active *,\n.smile-dark-scroll,\n.smile-studio-scroll-root {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(47, 169, 191, 0.45) rgba(255, 255, 255, 0.05);\n}\n\nbody.smile-portal-active::-webkit-scrollbar,\nbody.smile-portal-active *::-webkit-scrollbar,\n.smile-dark-scroll::-webkit-scrollbar,\n.smile-studio-scroll-root::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\nbody.smile-portal-active::-webkit-scrollbar-track,\nbody.smile-portal-active *::-webkit-scrollbar-track,\n.smile-dark-scroll::-webkit-scrollbar-track,\n.smile-studio-scroll-root::-webkit-scrollbar-track {\n  background: transparent;\n}\n\nbody.smile-portal-active::-webkit-scrollbar-thumb,\nbody.smile-portal-active *::-webkit-scrollbar-thumb,\n.smile-dark-scroll::-webkit-scrollbar-thumb,\n.smile-studio-scroll-root::-webkit-scrollbar-thumb {\n  background: rgba(47, 169, 191, 0.4);\n  border-radius: 999px;\n}\n\nbody.smile-portal-active::-webkit-scrollbar-thumb:hover,\nbody.smile-portal-active *::-webkit-scrollbar-thumb:hover,\n.smile-dark-scroll::-webkit-scrollbar-thumb:hover,\n.smile-studio-scroll-root::-webkit-scrollbar-thumb:hover {\n  background: rgba(54, 191, 216, 0.7);\n}\n\nbody.smile-portal-active::-webkit-scrollbar-button,\nbody.smile-portal-active *::-webkit-scrollbar-button,\n.smile-dark-scroll::-webkit-scrollbar-button,\n.smile-studio-scroll-root::-webkit-scrollbar-button {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n/* Keep stepper and style slider hidden even while portal scrollbar styles are active */\nbody.smile-portal-active .ss-stepper-scroll::-webkit-scrollbar,\n.smile-studio .ss-stepper-scroll::-webkit-scrollbar,\nbody.smile-portal-active .smile-style-slider::-webkit-scrollbar,\n.smile-studio .smile-style-slider::-webkit-scrollbar {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\nbody.smile-portal-active .ss-stepper-scroll,\n.smile-studio .ss-stepper-scroll,\nbody.smile-portal-active .smile-style-slider,\n.smile-studio .smile-style-slider {\n  scrollbar-width: none;\n}\n\n.smile-filter-slider-wrap {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  height: 220px;\n  overflow: hidden;\n  border-radius: 15px;\n}\n\n.smile-style-slider {\n  display: flex;\n  flex-wrap: nowrap;\n  width: 100%;\n  height: 100%;\n  overflow-y: hidden;\n  overflow-x: auto;\n  padding: 0;\n  scroll-behavior: smooth;\n  overscroll-behavior-x: contain;\n  scrollbar-width: none;\n}\n\n.smile-style-slider::-webkit-scrollbar {\n  display: none;\n  height: 0;\n  width: 0;\n}\n\n.smile-filter-slide {\n  position: relative;\n  flex: 0 0 auto;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.smile-filter-slide:hover {\n  z-index: 1;\n}\n\n.smile-filter-slide img {\n  height: 100%;\n  width: auto;\n  max-height: 100%;\n  margin: 0;\n  object-fit: contain;\n  object-position: center;\n  border-radius: 0;\n  cursor: pointer;\n  transition: 0.25s ease-in-out;\n  display: block;\n  background: #c1c1c3;\n}\n\n.smile-filter-slide-empty {\n  height: 100%;\n  width: 250px;\n  margin: 0;\n  border-radius: 0;\n  cursor: pointer;\n  transition: 0.25s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b6c72;\n  font-size: 12px;\n  background: #1f2124;\n}\n\n.smile-filter-slide img:hover,\n.smile-filter-slide-empty:hover {\n  transform: scale(1.05);\n  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.35);\n}\n\n.smile-filter-slide.is-selected {\n  z-index: 1;\n}\n\n.smile-filter-slide.is-selected::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border: 3px solid #1da8c6;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.smile-filter-slide.is-selected img,\n.smile-filter-slide.is-selected .smile-filter-slide-empty {\n  transform: none;\n  box-shadow: none;\n}\n\n.smile-filter-slide.is-selected img:hover,\n.smile-filter-slide.is-selected .smile-filter-slide-empty:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.smile-filter-slide-name {\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: 8px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  text-align: center;\n  line-height: 1.25;\n  white-space: normal;\n  background: rgba(0, 0, 0, 0.65);\n  opacity: 0;\n  pointer-events: none;\n  z-index: 3;\n  transition: opacity 0.2s ease;\n}\n\n.smile-filter-slide:hover .smile-filter-slide-name,\n.smile-filter-slide.is-selected .smile-filter-slide-name {\n  opacity: 1;\n}\n\n.smile-filter-slide.is-selected .smile-filter-slide-name {\n  background: #1da8c6;\n  color: #08151a;\n}\n\n.smile-filter-control {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 2;\n  height: auto;\n  width: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(28, 29, 32, 0.72);\n  color: #f1f0ea;\n  border: 0;\n  cursor: pointer;\n  user-select: none;\n}\n\n.smile-filter-control.prev {\n  left: 0;\n}\n\n.smile-filter-control.next {\n  right: 0;\n}\n\n.smile-filter-control:hover {\n  background: rgba(29, 168, 198, 0.85);\n  color: #08151a;\n}\n\n@media (max-width: 420px) {\n  .smile-filter-slider-wrap {\n    height: 180px;\n  }\n\n  .smile-filter-slide-empty {\n    width: 180px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
